import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from "lodash.pick";
import { getAction, httpAction } from "@api/manage";
export default {
  name: "TenantStreamingMediaModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "租户流媒体配置表表单",
      tableName: "sys_tenant_streaming_media",
      form_fields: ['platformType', 'platformAddress', 'appkey', 'appsecret', 'account', 'password', 'sslProxy', 'tenantId', 'sort'],
      form_fields_time: [],
      validatorRules: {
        platformType: {
          rules: [{
            required: true,
            message: '请输入平台类型!'
          }]
        },
        platformAddress: {
          rules: [{
            required: true,
            message: '请输入平台地址!'
          }]
        } // appkey: {rules: [{required: true, message: '请输入appKey!'}]},
        // appsecret: {rules: [{required: true, message: '请输入appSecret!'}]},
        // tenantId: {rules: [{required: true, message: '请输入租户ID!'}]},

      },
      tenantId: '',
      url: {
        streamingMedia: "/tenant/streaming/media",
        queryTenantStreamingMedia: "/tenant/streaming/media/queryTenantStreamingMedia/"
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields));
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          var httpurl = '',
              method = '';
          httpurl = _this2.url.streamingMedia;
          method = 'put';
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    loadTenantStreamingMedia: function loadTenantStreamingMedia(tenantId) {
      var that = this;
      getAction(this.url.queryTenantStreamingMedia + tenantId).then(function (res) {
        if (res.success) {
          that.model = res.result;
        }
      });
    }
  }
};